import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CentrifugoService, GameBaseApi,
  HockeyGameApi,
  HockeyGameLog,
  HockeyGameStatistic
} from '@mtgame/core';
import {
  GameProtocolService,
  STORE_LOGS_KEY,
  STORE_STATISTIC_KEY
} from '@core/services/game-protocol.service';
import { GameRootService } from '@core/services/game-root.service';

@Injectable()
export class HockeyGameProtocolService extends GameProtocolService {
  get statistic$(): Observable<HockeyGameStatistic[]> {
    return this.store.get(STORE_STATISTIC_KEY);
  }

  get logs$(): Observable<HockeyGameLog[]> {
    return this.store.get(STORE_LOGS_KEY);
  }

  constructor(
    protected gameRootService: GameRootService,
    private hockeyGameApi: HockeyGameApi,
    protected centrifugoService: CentrifugoService,
    protected gameBaseApi: GameBaseApi,
  ) {
    super(gameRootService, centrifugoService, gameBaseApi);
  }

  async getStatistic(): Promise<HockeyGameStatistic[]> {
    const statistic = await this.hockeyGameApi.getUserStatistic(this.gameId);
    this.store.save(STORE_STATISTIC_KEY, statistic);
    return statistic;
  }

  async getLogs(): Promise<HockeyGameLog[]> {
    const logs = await this.hockeyGameApi.getLogs(this.gameId);
    this.store.save(STORE_LOGS_KEY, logs);
    return logs;
  }

  protected onGameStatisticUpdated(data: any): void {
    this.store.updateItem(STORE_STATISTIC_KEY, HockeyGameStatistic.toFront(data));
  }

  protected onGameLogAdded(data: any): void {
    this.store.appendItem(STORE_LOGS_KEY, HockeyGameLog.toFront(data));
  }

  protected onGameLogUpdated(data: any): void {
    this.store.updateItem(STORE_LOGS_KEY, HockeyGameLog.toFront(data));
  }
}
